<template>
    <div class="d-flex flex-column justify-content-between options-menu">
        <nav class="options-menu__nav">
            <ul class="options d-flex flex-row flex-wrap flex-lg-column justify-content-around options-menu__list">
                <app-page-options-item
                    v-for="(option, index) in orderedOptions"
                    :key="index"
                    :to="option.to"
                    :label="option.label || option.name"
                    :icon="option.icon"
                />

                <li class="options__item corp-orange" v-if="!user.profile.client_side">
                    <router-link :to="{ name: 'documentation' }" class="d-flex align-items-center justify-content-start options__link--primary">
                        <span> Documentación</span>
                    </router-link>
                </li>
            </ul>
        </nav>
    </div>
</template>
<script>
    import PageOptionsItem from './PageOptionsItem.vue';
    import { mapGetters } from 'vuex';

    export default {
        components: {
            AppPageOptionsItem: PageOptionsItem
        },
        props: {
            options: {
                type: Array,
                required: true
            }
        },
        computed: {
            ...mapGetters(['client', 'user']),
            clientHasContractorModule() {
                const client = this.client;
                if (!client || !client.id) return false;
                let modules = client.optional_modules || client.optionalModules;
                if (!modules || !Array.isArray(modules)) {
                    const user = this.user;
                    const userClients = user && (user.clients || user.clients_list);
                    if (userClients && Array.isArray(userClients)) {
                        const sameClient = userClients.find(c => c.id === client.id);
                        modules = sameClient && (sameClient.optional_modules || sameClient.optionalModules);
                    }
                }
                if (!modules || !Array.isArray(modules)) return false;
                return modules.some(m => m && (m.slug === 'contractor' || (m.slug && m.slug.toLowerCase() === 'contractor')));
            },
            visibleOptions() {
                return this.options.filter(option => {
                    if (option.to === 'contractorDocumentTypesPage' || option.to === 'contractorManagementPage') {
                        return this.clientHasContractorModule;
                    }
                    return true;
                });
            },
            orderedOptions() {
                return [...this.visibleOptions].sort((a, b) => (a.order || 0) - (b.order || 0));
            }
        }
    }
</script>